import {Component, EventEmitter, Input, OnInit, Output,} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {
  CalendarViewType,
  EventItem,
  getRegistrationClosesDays,
  isFinishedEvent,
  LeagueEventType,
  Lookups,
} from "@model";
import {AbstractComponent} from "../abstract.component";
import {LocalStorageService} from "@services";
import {LeagueTemplateEventStatus} from "../../model/league/league-template-event-status";
import {EVENT_CALENDAR_ROUTE, FINISHED_EVENTS_ROUTE} from "src/app/app-routing.module";
import {buildEventSlug} from "@utility";

@Component({
    selector: 'app-event-grid-item',
    templateUrl: './event-grid-item.component.html',
    styleUrls: ['./event-grid-item.component.scss'],
    standalone: false
})
export class EventGridItemComponent extends AbstractComponent implements OnInit {
  @Input() eventItem?: EventItem;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() isPreviewComponent?: boolean;
  @Input() zoomEffect = false;
  @Input() layout: CalendarViewType | undefined;
  @Input() showActionButton : boolean = true;
  @Input() isClickable : boolean = false;
  @Input() isLeagueEvent : boolean = false;
  @Input() hasBorder = true;
  @Input() hasIcons = true;
  @Input() hasShare = false;
  @Input() hasFavorite = true;
  @Input() hideShadow: boolean = false;
  @Input() showCompetitorCount: boolean = true;
  @Input() showRegistrationCloses: boolean = false;
  @Output() onRightButtonClickCallback: EventEmitter<void> = new EventEmitter<void>();
  @Input() smallImage: boolean = false;

  isFinishedEvent = false;
  isBonusEvent = false;
  showEventBanner = false
  currentLayout: CalendarViewType = CalendarViewType.LIST;
  registrationClosesDays: number | undefined;
  eventDetailsUrl = '';


  constructor(public translocoService: TranslocoService,
              private localStorageService: LocalStorageService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.eventItem) {
      this.isFinishedEvent = isFinishedEvent(this.eventItem);
      const base = this.isFinishedEvent ? FINISHED_EVENTS_ROUTE : EVENT_CALENDAR_ROUTE;
      this.eventDetailsUrl = `${base}/eventDetails/${buildEventSlug(this.eventItem.id!, this.eventItem)}`;
    }
    if (this.isLeagueEvent) {
      this.showEventBanner = this.eventItem?.leagueTemplateStatus === LeagueTemplateEventStatus.CANCELLED ||
                             this.eventItem?.leagueTemplateStatus === LeagueTemplateEventStatus.EXTERNAL ||
                             this.eventItem?.leagueTemplateStatus === LeagueTemplateEventStatus.ACTIVE;
      this.isBonusEvent = this.eventItem?.leagueEventType === LeagueEventType.BONUS;
    }
    if (this.showEventBanner) {
      this.showRegistrationCloses = false;
    }
    if (this.showRegistrationCloses) {
      this.registrationClosesDays = getRegistrationClosesDays(this.eventItem);
    }

    this.updateLayout();
    this.subscriptions.push(
        this.isMobile$.subscribe(() => this.updateLayout()),
        this.isMdScreen$.subscribe(() => this.updateLayout()),
        this.localStorageService.currentLayout$.subscribe(() => this.updateLayout())
    );
  }

  private updateLayout(): void {
    this.currentLayout = this.layout ?? (this.isMdScreen || this.isMobile
        ? CalendarViewType.GRID
        : this.localStorageService.currentLayout);
  }



  handleCardClick() {
    if (this.isClickable) {
      this.onRightButtonClick();
    }
  }

  onRightButtonClick(): void {
    this.onRightButtonClickCallback.emit();
  }


  protected readonly CalendarViewType = CalendarViewType;
  protected readonly LeagueTemplateEventStatus = LeagueTemplateEventStatus;

  readonly statusBanners: Partial<Record<LeagueTemplateEventStatus, {icon: string, color: string, key: string}>> = {
    [LeagueTemplateEventStatus.CANCELLED]: { icon: 'warning-icon-red', color: 'color-red-600', key: 'app.common.canceled' },
    [LeagueTemplateEventStatus.ACTIVE]: { icon: 'warning-icon-blue', color: 'color-blue-600', key: 'app.common.details.coming.soon' },
    [LeagueTemplateEventStatus.EXTERNAL]: { icon: 'warning-icon-red', color: 'color-red-600', key: 'league.template.event.status.3' },
  };
}
